import { MemberCell } from '@hlth/admin/attendee-management/attendee-management-details/attendee-management-details-applications/member-cell/member-cell';

export const PREMIUM_MEMBERSHIP_ICON = 'hlth:dollar';
export const FREE_ICON = 'hlth:free';
export const TRIAL_ICON = 'hlth:timer';

export function getIconFrom(memberCell: MemberCell) {
  if (memberCell.userHasPremiumMembership) {
    return PREMIUM_MEMBERSHIP_ICON;
  }

  if (memberCell.userHasTrialMembership) {
    return TRIAL_ICON;
  }

  if (memberCell.userHasFreeMembership) {
    return FREE_ICON;
  }

  return null;
}

export function getTextFrom(memberCell: MemberCell) {
  if (memberCell.userHasPremiumMembership) {
    return 'Premium Membership';
  }

  if (memberCell.userHasTrialMembership) {
    return 'Trial Membership';
  }

  if (memberCell.userHasFreeMembership) {
    return 'Free Membership';
  }

  return null;
}
